import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApiLavandierService } from '../../../../lib/lib-ngx/web-services/api-lavandier.service';
import { ErrorService } from '../../../../lib/lib-ngx/services/error.service';

@Component({
  selector: 'lm-user-profile-intercom-redirect',
  templateUrl: './user-profile-intercom-redirect.component.html',
  styleUrls: ['./user-profile-intercom-redirect.component.scss']
})
export class UserProfileIntercomRedirectComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private apiLavandierService: ApiLavandierService,
    private errorService: ErrorService,
  ) {
  }

  ngOnInit() {
    const userId = this.activatedRoute.snapshot.params.id;
    this.apiLavandierService.getUserIntercomRedirect(userId, {})
      .subscribe(data => {
        if (!this.errorService.manageError(data)) {
          window.location.href = data.url;
        }
      });
  }
}
